<script setup>
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import { faFacebookSquare, faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons';
    import { faGlobe } from '@fortawesome/pro-solid-svg-icons';
    import { Link } from '@inertiajs/vue3';
    import { useRoute } from 'inertiaRoutes';

    const route = useRoute();

    library.add(faFacebookSquare, faInstagram, faLinkedin, faGlobe);
</script>

<template>
    <!-- CURVE -->
    <div class="position-relative">
        <div class="shape shape-bottom shape-fluid-x text-dark">
            <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="none">
                <path d="M0 48h2880V0h-720C1442.5 52 720 0 720 0H0v48z" fill="currentColor" />
            </svg>
        </div>
    </div>

    <!-- FOOTER -->
    <footer class="py-8 py-md-11 bg-dark">
        <div class="container">
            <div class="row gy-3">
                <div class="col-12 col-md-4 col-lg-3">
                    <!-- Brand -->
                    <h3 class="footer-brand fw-bolder">
                        {{ $t('AO Interview Hub') }}
                    </h3>

                    <!--                    <img src="./assets/img/brand.svg" alt="..." class="footer-brand img-fluid mb-2">-->

                    <!-- Text -->
                    <p class="text-gray-700 mb-2">
                        {{ $t('All rights reserved.') }}<br />
                        {{
                            $t('Copyright Dinotek &copy; :year', {
                                year: new Date().getFullYear()
                            })
                        }}
                    </p>

                    <!-- Social -->
                    <ul class="list-unstyled list-inline list-social mb-6 mb-md-0">
                        <li class="list-inline-item list-social-item me-3">
                            <a
                                href="https://www.facebook.com/AOGlobeLife?mibextid=LQQJ4d"
                                class="text-decoration-none"
                                aria-label="Facebook">
                                <font-awesome-icon
                                    :icon="['fab', 'fa-facebook-square']"
                                    class="text-gray-600"
                                    size="lg" />
                            </a>
                        </li>
                        <li class="list-inline-item list-social-item me-3">
                            <a
                                href="https://www.instagram.com/aoglobelife"
                                class="text-decoration-none"
                                aria-label="Instagram">
                                <font-awesome-icon
                                    :icon="['fab', 'fa-instagram']"
                                    class="text-gray-600"
                                    size="lg" />
                            </a>
                        </li>
                        <li class="list-inline-item list-social-item me-3">
                            <a
                                href="https://www.linkedin.com/company/american-income-life-ao"
                                class="text-decoration-none"
                                aria-label="Linked In">
                                <font-awesome-icon
                                    :icon="['fab', 'fa-linkedin']"
                                    class="text-gray-600"
                                    size="lg" />
                            </a>
                        </li>
                        <li class="list-inline-item list-social-item">
                            <a
                                href="https://www.aoworkfromanywhere.com/"
                                class="text-decoration-none"
                                aria-label="AO Work From Anywhere">
                                <font-awesome-icon
                                    :icon="['fas', 'fa-globe']"
                                    class="text-gray-600"
                                    size="lg" />
                            </a>
                        </li>
                    </ul>
                    <div id="g-recaptcha" class="mt-3" />
                </div>
                <div class="col-6 col-md-4 col-lg-2">
                    <!--                    &lt;!&ndash; Heading &ndash;&gt;-->
                    <!--                    <h6 class="fw-bold text-uppercase text-gray-700">Languages</h6>-->

                    <!--                    &lt;!&ndash; List &ndash;&gt;-->
                    <!--                    <ul class="list-unstyled text-body-secondary mb-6 mb-md-8 mb-lg-0">-->
                    <!--                        <li v-for="locale of $page.props.locales" class="mb-3">-->
                    <!--                            <a :href="locale.url" class="text-reset">{{ locale.name }}</a>-->
                    <!--                        </li>-->
                    <!--                    </ul>-->
                </div>
                <div class="col-6 col-md-4 col-lg-2">
                    <!--                    &lt;!&ndash; Heading &ndash;&gt;-->
                    <!--                    <h6 class="fw-bold text-uppercase text-gray-700">{{ $t('Legal') }}</h6>-->

                    <!--                    &lt;!&ndash; List &ndash;&gt;-->
                    <!--                    <ul class="list-unstyled text-body-secondary mb-6 mb-md-8 mb-lg-0">-->
                    <!--                        <li class="mb-3">-->
                    <!--                            <Link class="text-reset" :href="route('privacy')">-->
                    <!--                                {{ $t('Privacy Policy') }}-->
                    <!--                            </Link>-->
                    <!--                        </li>-->
                    <!--                        <li class="mb-3">-->
                    <!--                            <Link class="text-reset" :href="route('terms')">-->
                    <!--                                {{ $t('Terms') }}-->
                    <!--                            </Link>-->
                    <!--                        </li>-->
                    <!--                        <li class="mb-3">-->
                    <!--                            <Link class="text-reset" :href="route('accessibility')">-->
                    <!--                                {{ $t('Accessibility') }}-->
                    <!--                            </Link>-->
                    <!--                        </li>-->
                    <!--                    </ul>-->
                </div>
                <div class="col-6 col-md-4 offset-md-4 col-lg-2 offset-lg-0">
                    <!-- Heading -->
                    <h6 class="fw-bold text-uppercase text-gray-700">Languages</h6>

                    <!-- List -->
                    <ul class="list-unstyled text-body-secondary mb-6 mb-md-8 mb-lg-0">
                        <li v-for="locale of $page.props.locales" class="mb-3">
                            <a :href="locale.url" class="text-reset">{{ locale.name }}</a>
                        </li>
                    </ul>
                </div>
                <div class="col-6 col-md-4 col-lg-2">
                    <!-- Heading -->
                    <h6 class="fw-bold text-uppercase text-gray-700">{{ $t('Legal') }}</h6>

                    <!-- List -->
                    <ul class="list-unstyled text-body-secondary mb-6 mb-md-8 mb-lg-0">
                        <li class="mb-3">
                            <Link class="text-reset" :href="route('privacy')">
                                {{ $t('Privacy Policy') }}
                            </Link>
                        </li>
                        <li class="mb-3">
                            <Link class="text-reset" :href="route('terms')">
                                {{ $t('Terms') }}
                            </Link>
                        </li>
                        <li class="mb-3">
                            <Link class="text-reset" :href="route('accessibility')">
                                {{ $t('Accessibility') }}
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- / .row -->
        </div>
        <!-- / .container -->
    </footer>
</template>

<style scoped></style>
